export const headerLinks = {
  services: [
    {
      link: "test-drive-bookings",
      text: "Test Drive Bookings",
    },
    {
      link: "service-bookings",
      text: "Service Bookings",
    },
    {
      link: "roadside-assistance",
      text: "Roadside Assistance",
    },
  ],
  management: [
    {
      link: "faq",
      text: "FAQ",
    },
    {
      link: "terms-and-conditions",
      text: "PP and T&C",
    },
    {
      link: "sales-force",
      text: "Sales Force",
    },
    {
      link: "link-management",
      text: "Links",
    },
    {
      link: "notifications",
      text: "Notifications",
    },
    {
      link: "warranty",
      text: "Warranty",
    },
    {
      link: "call-centre",
      text: "Call Centre",
    },
  ],
};

export const SUPPORTED_CALL_CENTRE_BRANDS = ["Toyota"];

export const canAccessManagementModule = (moduleList, link, brand) => {
  const modules = moduleList ?? [];
  if (link === "call-centre") {
    if (brand && !SUPPORTED_CALL_CENTRE_BRANDS.includes(brand)) {
      return false;
    }
    return (
      modules.includes("call-centre") ||
      modules.includes("terms-and-conditions") ||
      modules.length === 0
    );
  }
  if (modules.includes(link)) {
    return true;
  }
  if (link === "warranty" && modules.includes("notifications")) {
    return true;
  }
  return false;
};

export const canAccessWarrantyModule = (moduleList) =>
  canAccessManagementModule(moduleList, "warranty");

export const canAccessCallCentreModule = (moduleList, brand) =>
  canAccessManagementModule(moduleList, "call-centre", brand);
